import * as React from 'react';

export const InfoIcon: React.FunctionComponent<{
  color: string;
  ariaName?: string;
}> = ({ color, ariaName }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <mask
        id="mask"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="12"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8.75 7V11.75H7.25V7H8.75ZM8 4C7.4 4 7 4.4 7 5C7 5.6 7.4 6 8 6C8.6 6 9 5.5 9 5C9 4.4 8.6 4 8 4Z"
          fill={color}
        />
      </mask>
      <g mask={`url(#mask)`}>
        <rect width="16" height="16" fill={color} />
      </g>
    </svg>
  );
};
